import { render, staticRenderFns } from "./kovertStatus.vue?vue&type=template&id=6402c015&scoped=true&"
import script from "./kovertStatus.vue?vue&type=script&lang=js&"
export * from "./kovertStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6402c015",
  null
  
)

export default component.exports